import { every } from "lodash";
import store from "./index";

function virtualFactory(
  storeName,
  idAttribute,
  attributeToFilter,
  valueToFilter
) {
  return {
    actions: {
      async get({ commit, state, getters, dispatch }, id) {
        if (!state.list.length && !state.listPromise) {
          await dispatch("list");
        }
        const record = getters.getById(id);

        commit("setRecord", record);
        return state.record;
      },
      async list(
        { commit, state, dispatch },
        { reload = true } = { reload: true }
      ) {
        if ((!state.list.length && !state.listPromise) || reload) {
          commit(
            "setListPromise",
            dispatch(`${storeName}/list`, { reload: false }, { root: true })
          );

          let list = await state.listPromise;
          list = list.filter(item => {
            if (item && item[attributeToFilter] === valueToFilter) {
              return item;
            }
            return;
          });

          commit("setList", list);
          commit("setListPromise", null);
        } else if (state.listPromise) {
          await state.listPromise;
        }
        return state.list;
      },
    },
    getters: {
      filter: state => (filterMap, id) => {
        if (id) {
          filterMap = Object.assign({}, filterMap, { [idAttribute]: id });
        }

        return state.list.filter(item => {
          return every(filterMap, (filterValue, filterAttribute) => {
            return item[filterAttribute] === filterValue;
          });
        });
      },
      filterByAttributeValue: state => (attribute, value, joinList) => {
        if (!attribute) {
          return [];
        }

        const filteredList = state.list.filter(item => {
          if (item[attribute] === undefined) {
            return false;
          }

          return item[attribute] === value;
        });

        if (Array.isArray(joinList) && joinList.length) {
          filteredList.forEach(item => {
            joinList.forEach(join => {
              const getter = store.getters[`${join.entity}/getById`];
              const record = getter(item[join.attribute]);
              item[join.entity] = record;
            });
          });
        }

        return filteredList;
      },
      getById: state => findId => {
        return state.list.find(item => {
          if (Number.isInteger(state.list[0][idAttribute])) {
            return item[idAttribute] === Number(findId);
          }
          return item[idAttribute] === findId;
        });
      },
    },
    mutations: {
      setList(state, list) {
        state.list = list;
      },
      setListPromise(state, value) {
        state.listPromise = value;
      },
      setRecord(state, record) {
        state.record = record;
      },
    },
    namespaced: true,
    state: {
      list: [],
      listPromise: null,
      record: {},
    },
  };
}

export default virtualFactory;
